/**
 * The Company Roadmap module's permission vocabulary.
 *
 * Two rungs, and the ladder is flatter than it looks. In practice everyone granted access
 * gets Edit: this replaces a shared Google Doc where any leader could edit anything, and a
 * tool that is *tighter* than the norm it replaces just pushes the work back into the doc.
 * There is deliberately no per-item ownership check anywhere in the module — no "only the
 * owner may edit this win". Comments are append-only, which is the one place that rule
 * would have been felt.
 *
 * `view` exists so that a read-only share to non-leaders is a GRANT rather than a rebuild:
 * the read path already renders from the same payload, and the edit affordances key off
 * `roadmap:edit`. Nothing is built specially for it today.
 *
 * Not granted to the All Users group (unlike Org Chart) — see platform/groups.ts. Access is
 * given per group in the Admin section.
 */
import { defineModulePermissions } from '@noissue/authz';

export const ROADMAP = defineModulePermissions({
  id: 'roadmap',
  name: 'Company Wall Planner',
  icon: 'calendar-range',
  permissions: {
    view: {
      label: 'View the planner',
      description: 'See the quarterly planner and the quarterly wins on it.',
    },
    edit: {
      label: 'Edit the planner',
      description: 'Add and change swimlanes, quarterly wins and ripples.',
    },
  },
  visibility: 'view',
  levels: [
    { key: 'view', label: 'View', grants: ['view'] },
    { key: 'edit', label: 'Edit', grants: ['view', 'edit'] },
  ],
});
